import { IAttendanceRosterUpload } from "common/interface/IAttendanceRosterUpload";

const PERSIST_KEY = "attendance_roster_processing";

export const persistProcessingAttendanceRoster = (data: IAttendanceRosterUpload) => {
  try {
    localStorage.setItem(PERSIST_KEY, JSON.stringify(data));
  } catch (error) {
    console.error("Error persisting Attendance Roster data:", error);
  }
};

export const getPersistedProcessingAttendanceRoster = (): IAttendanceRosterUpload => {
  try {
    const data = localStorage.getItem(PERSIST_KEY);
    return data ? JSON.parse(data) : {};
  } catch (error) {
    console.error("Error retrieving Attendance Roster data:", error);
    return {};
  }
};

export const removePersistedProcessingAttendanceRoster = () => {
  try {
    localStorage.removeItem(PERSIST_KEY);
  } catch (error) {
    console.error("Error removing Attendance Roster data:", error);
  }
};
